import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faExclamationTriangle,
  faChartLine,
  faLayerGroup,
} from '@fortawesome/free-solid-svg-icons';
import { MockGridCard, MetricRow, MetricSection } from '../shared/MockGridCard';

const BaselineResultsMock = () => (
  <div className="space-y-4">
    <p className="text-[10px] font-mono uppercase tracking-widest text-gray-500">Example outputs</p>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* Cross-Asset Behaviour */}
      <MockGridCard title="Cross-Asset Behaviour" icon={faChartLine} iconColor="text-blue-400">
        <div className="space-y-1.5">
          <MetricSection label="Per-Asset Returns" />
          {[
            { asset: 'BTCUSDT', ret: '+12.4%', profitable: true },
            { asset: 'ETHUSDT', ret: '+8.7%', profitable: true },
            { asset: 'SOLUSDT', ret: '+3.1%', profitable: true },
            { asset: 'ADAUSDT', ret: '+15.2%', profitable: true },
            { asset: 'DOTUSDT', ret: '-2.8%', profitable: false },
            { asset: 'LINKUSDT', ret: '+6.9%', profitable: true },
          ].map((a) => (
            <div key={a.asset} className="flex justify-between items-center text-xs">
              <span className="text-gray-400">{a.asset}</span>
              <span className={a.profitable ? 'text-gray-300' : 'text-gray-500'}>{a.ret}</span>
            </div>
          ))}
          <div className="pt-2 border-t border-white/[0.04] mt-2">
            <div className="text-[10px] text-gray-500 italic">5/6 assets profitable with default parameters.</div>
          </div>
        </div>
      </MockGridCard>

      {/* Cross-Asset Risk */}
      <MockGridCard title="Cross-Asset Risk" icon={faExclamationTriangle} iconColor="text-amber-400">
        <MetricSection label="Drawdown Envelope" />
        <MetricRow label="Median Drawdown" value="-8.2%" />
        <MetricRow label="Worst Drawdown" value="-14.7%" />
        <MetricRow label="Best Drawdown" value="-3.1%" />
        <div className="mt-4 mb-2">
          <MetricSection label="Risk Profile" />
          <MetricRow label="Return Std Dev" value="4.3%" />
          <MetricRow label="Sharpe (median)" value="1.18" />
        </div>
        <div className="pt-2 border-t border-white/[0.04] mt-auto">
          <div className="text-[10px] text-gray-500 italic">Risk envelope within acceptable bounds.</div>
        </div>
      </MockGridCard>

      {/* Parameter Stability */}
      <MockGridCard title="Parameter Stability" icon={faLayerGroup} iconColor="text-purple-400">
        <MetricSection label="Stability Metrics" />
        <MetricRow label="Consistency" value="0.74" />
        <MetricRow label="Robustness" value="0.68" />
        <div className="mt-4 mb-2">
          <MetricSection label="Stable Region" />
          <div className="text-xs text-gray-400 space-y-1">
            <div className="flex justify-between"><span>fastLength</span><span className="text-gray-300">8 - 14</span></div>
            <div className="flex justify-between"><span>slowLength</span><span className="text-gray-300">18 - 28</span></div>
          </div>
        </div>
        <div className="pt-2 border-t border-white/[0.04] mt-auto">
          <div className="text-[10px] text-gray-500 italic">Stable parameter region identified.</div>
        </div>
      </MockGridCard>
    </div>

    {/* Outcome classification badge */}
    <div className="bg-[#181825] rounded-lg border border-white/[0.06] px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <span className="px-2 py-1 rounded text-[10px] uppercase tracking-wide bg-lime-300/10 text-lime-200 font-semibold">Robust</span>
        <span className="text-sm text-gray-300">Strategy generalizes across assets. Proceed to walk-forward analysis.</span>
      </div>
      <span className="text-xs text-gray-500">5/6 profitable</span>
    </div>
  </div>
);

export default BaselineResultsMock;
